import lessRequire from '../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import SelectField from '../shared/form-elements/select';
import InputField from '../shared/form-elements/input';
import isNull from 'lodash/isNull';
import flatten from 'lodash/flatten';
import find from 'lodash/find';
import cn from 'classname';

import { getCurrencyIcon } from '../../../shared/js/get-currency-icon';
lessRequire('modules/affiliates/targets.less');

const SelectFieldWithFlag = props => {
	return (
		<div>
			<SelectField {...props}>
				<span
					className={`select-image select-image__flag flag-icon flag-icon-${props.countryCode.toLowerCase()}`}
				/>
				{props.shouldShowBoostIcon && <span className="boost-icon" />}
			</SelectField>
		</div>
	);
};

SelectFieldWithFlag.propTypes = {
	countryCode: PropTypes.string,
	shouldShowBoostIcon: PropTypes.bool
};

const Targets = props => {
	if (props.fields.length === 0) return null;
	return (
		<tr className="targets-form__wrap">
			<td colSpan={8}>
				<table className="targets-form__table">
					<thead className="entity-wrap__table-head font-proxima-nova-semibold">
						<tr>
							<th className="location">
								<span>{props.intl('Гео')}</span>
							</th>
							{props.payoutCurrencies.map(({ id }, index) =>
								<th className="price" key={index}>
									<span>{props.intl('Выпл.') + `, ${getCurrencyIcon(id)}`}</span>
								</th>
							)}
						</tr>
					</thead>
					<tbody className="entity-wrap__table-body">
						{flatten(
							props.fields.map((parentName, index, fields) => {
								const target = fields.get(index);

								const countryCode = target.country_code || '';
								const masterTarget = target.masterTarget;
								const payoutDiff = getPayoutDiff(target, masterTarget);
								const shouldDisablePayoutInputs =
									(target && (target.status !== 'active' && !isNull(target.amount)))
									|| !isNull(masterTarget.boost_till)
									|| target.masterTarget.is_locked;

								const offerId = target.offer_id;
								const locationId = target.location_id.value;
								const affiliateId = target.affiliate_id;

								const wasBoostNullified = !!find(props.nullifiedBoosts, {
									offerId,
									locationId,
									affiliateId
								});
								const shouldShowBoostIcon =
									(!wasBoostNullified && target.boost_till !== null) ||
									!isNull(masterTarget.boost_till);

								return [
									<tr
										key={index}
										className={cn({
											'entity-aff-form-target': true,
											'last-target': index === fields.length - 1
										})}
									>
										<td className="location">
											<div className="ui-form__element location__field">
												<Field
													name={`${parentName}.location_id`}
													placeholder=""
													component={SelectFieldWithFlag}
													countryCode={countryCode}
													shouldShowBoostIcon={shouldShowBoostIcon}
													shouldDisable={true}
													searchable={false}
													multi={false}
													options={[]}
												/>
											</div>
										</td>
										{props.payoutCurrencies.map(({ id }, index) =>
											<td className={`price ${index > 0 ? 'last' : ''}` } key={index}>
												<div
													className={`ui-form__element ${
														payoutDiff[id] && payoutDiff[id].className
													} ${shouldDisablePayoutInputs ? 'opacity_5' : ''}`}
												>
													<Field
														name={`${parentName}.${id}`}
														placeholder={payoutDiff[id] && payoutDiff[id].masterAmount || ''}
														component={InputField}
														shouldDisable={shouldDisablePayoutInputs}
														onChange={() =>
															props.nullifyBoostOnSubmit({
																offerId,
																locationId,
																affiliateId
															})
														}
													/>
												</div>
											</td>
										)}
									</tr>,
									<tr key={`targets-padding-${index}`} className="padding-tr" />
								];
							})
						)}
					</tbody>
				</table>
			</td>
		</tr>
	);
};

const getPayoutDiff = (field, masterTarget) => {
	const calcDiff = currency => {
		const masterAmount =
			(masterTarget && parseInt(masterTarget[currency])) || 0;
		const childAmount = (field && parseInt(field[currency])) || 0;

		return masterTarget && field && childAmount !== masterAmount
			? { className: 'payout-diff', masterAmount: masterAmount.toString() }
			: { className: '', masterAmount: null };
	};

	return {
		rub: calcDiff('rub'),
		eur: calcDiff('eur'),
		usd: calcDiff('usd')
	};
};

Targets.propTypes = {
	fields: PropTypes.object,
	nullifyBoostOnSubmit: PropTypes.func,
	nullifiedBoosts: PropTypes.array,
	intl: PropTypes.func
};

export default Targets;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/affiliates/targets.js